import { css } from 'styled-jsx/css';
import breakPoints from 'helpers/Styles';

export default css`
  .pc-model-wrapper {
    color: white;
  }

  .pc-model-config-container {
    /* min-width: 1200px; */
    margin-top: 72px;
  }
  .sticky-container-desktop {
    margin-top: 176px;
  }

  .pc-model-config-options {
    /* padding: 0 48px 104px 48px; */
    display: flex;
    flex-direction: row;
    flex-grow: 1;
    align-items: flex-start;
    padding-bottom: 30px;
  }
  .pc-configurator {
    padding-top: 80px;
    margin-top: -80px;
  }

  body.customize-page-product .zopim {
    z-index: 99999999999999999999999 !important;
    bottom: 92px !important;
  }
  @media screen and (max-width: 1022px) {
    body.customize-page-product .zopim {
      z-index: 99999999999999999999999 !important;
      bottom: 150px !important;
    }
  }
  @media (max-width: 1024px) {
    .pc-model-config-container {
      min-width: unset;
    }
    .pc-model-config-options {
      flex-direction: column;
    }

    .pc-model-config-options {
      padding: 0;
    }
  }

  .video-container {
    width: 99.5%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-bottom: 2%;
  }
  .video-section {
    width: 22%;
    background-color: #2f2f2f;
    height: 188px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border: 1px solid #2f2f2f;
    border-radius: 2px;
    overflow: hidden;
  }
  .description-section {
    width: 78%;
    display: flex;
    flex-direction: column;
    padding-left: 30px;
    padding-right: 30px;
    margin-left: 10px;
  }
  .header {
    font-family: 'big_noodle_titling';
    font-size: 40px;
    margin: 0;
  }
  .description {
    margin: 3% 0 2% 0;
    font-size: 14px;
    width: 72.6%;
  }
  .watch-video-container {
    display: flex;
    justify-content: start;
    align-items: center;
    cursor: pointer;
  }
  .watch-video {
    font-size: 24px;
    font-family: 'big_noodle_titling';
  }
  .circled-play {
    width: 30px;
    height: 30px;
    margin-right: 8px;
  }
  .circled-play-white {
    width: 90px;
    height: 90px;
  }
  .modal-btn-close {
    position: absolute;
    right: 20px;
    background-color: #950810;
    border: 1px solid #950810;
    padding: 5px;
    border-radius: 3px;
    color: white;
  }
  .ultralabs-video-container {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: black;
    height: 90%;
    margin-top: 15px;
  }
  .modal-header {
    margin: 0;
    font-family: 'big_noodle_titling';
    font-size: 24px;
    width: 85%;
  }
  .ultralabs-video-dekstop {
    display: flex;
  }
  .ultralabs-video-mobile {
    display: none;
  }
  .video-container-mobile {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 80px;
    height: 60px;
    background-color: #313131;
    border: 1px solid #2f2f2f;
    border-radius: 2px;
    overflow: hidden;
  }
  .circled-play-mobile {
    width: 30px;
    height: 30px;
  }
  .description-container-mobile {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: start;
    margin-left: 10px;
  }
  .header-mobile {
    font-size: 16px;
    margin: 0;
    font-family: 'big_noodle_titling';
  }
  .click-more {
    font-size: 12px;
    color: #950810;
    margin-top: 10px;
    text-decoration: underline;
  }
  .toggle-icon-con {
    color: #d10e18;
    top: 50%;
    bottom: 50%;
    right: 3%;
    font-family: 'Roboto-Medium';
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
  }
  .toggle-icon {
    width: 20px;
    height: 20px;
  }
  .video-section-mobile {
    display: flex;
  }
  .description-section-mobile {
    justify-content: center;
    align-items: center;
    border-top: 1px solid #5f5f5f;
    margin-top: 15px;
    flex-direction: column;
  }
  .description-mobile {
    text-align: center;
    font-size: 14px;
  }
  .watch-btn-con {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #2f2f2f;
    padding: 5px 12px 5px 10px;
    border-radius: 3px;
  }
  @media (max-width: ${breakPoints.medium}) {
    .steps {
      display: none;
    }
    .pc-model-config-container {
      margin-top: 100px;
    }
    .sticky-container-tablet {
      margin-top: 100px;
    }
  }
  @media (max-width: ${breakPoints.small}) {
    .steps {
      display: none;
    }
    .pc-model-config-container {
      margin-top: 40px !important;
    }
    .sticky-container-tablet {
      margin-top: 40px !important;
    }
  }
  @media (max-width: ${breakPoints.mobileL}) {
    .pc-model-config-container {
      margin-top: 72px;
    }
    .ultralabs-video-container {
      height: 90%;
      overflow: none;
    }
    .modal-header {
      font-size: 17px;
      width: 90%;
    }
    .modal-btn-close {
      border-radius: 25px;
      width: 25px;
      height: 25px;
      top: 3%;
      right: 2%;
      font-size: 11px;
      text-transform: lowercase;
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: bold;
    }
    .ultralabs-video-dekstop {
      display: none;
    }
    .ultralabs-video-mobile {
      display: flex;
      justify-content: start;
      align-items: center;
      padding: 10px;
      background-color: #141414;
      margin-bottom: 20px;
      border: 2px solid #232323;
      flex-direction: column;
    }
  }
`;

export const global = css.global`
  @media (max-width: 1024px) {
    .sticky-wrapper {
      width: 100%;
      z-index: 2;
    }
  }
  .ReactModal__Overlay {
    z-index: 9;
  }
`;
